import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { Icons } from '../icons/Icons';
import { useStyling } from '../Theme';
import I18n from '../i18n/I18n';
import { SIZES } from '../constants/constants';

type BackButtonProps = {
    onClick: () => void;
};

export default ({ onClick }: BackButtonProps) => {
    const { theme } = useStyling();
    return (
        <Tooltip title={<I18n token="dialog.back" />}>
            <IconButton
                size={SIZES.small}
                onClick={(e) => {
                    e.stopPropagation();
                    onClick();
                }}
                sx={{ mr: 1 }}
                aria-label={'back'}
            >
                <Icons.BackButton fontSize={SIZES.small} sx={{ color: theme.palette.text.primary }} />
            </IconButton>
        </Tooltip>
    );
};
